"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const prop_types_1 = __importDefault(require("prop-types"));
const react_1 = __importDefault(require("react"));
require("./DescriptionModal.scss");
const DescriptionModalStyles_1 = require("./DescriptionModalStyles");
const DescriptionModal = (props) => {
    const { title, close, descriptionFull, textRules } = props;
    const building = `Edifício${'\u00A0'}`;
    return (react_1.default.createElement("div", { className: "DescriptionModal" },
        react_1.default.createElement("div", { className: "name" },
            textRules ? `${textRules} / ${building}` : building,
            react_1.default.createElement("span", null, title)),
        react_1.default.createElement(DescriptionModalStyles_1.CloseButton, { onClick: close }, "X"),
        react_1.default.createElement("div", { className: "paragraph" },
            react_1.default.createElement("p", { dangerouslySetInnerHTML: { __html: descriptionFull } }))));
};
DescriptionModal.propTypes = {
    title: prop_types_1.default.string,
    descriptionFull: prop_types_1.default.string,
    close: prop_types_1.default.func.isRequired,
    textRules: prop_types_1.default.string,
};
DescriptionModal.defaultProps = {
    title: '360 LUZ',
    descriptionFull: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur sed
  tellus ut metus faucibus pulvinar.Orci varius natoque penatibus et
  magnis dis parturient montes, nascetur ridiculus mus.Mauris rhoncus,
    arcu non ultrices pharetra, sem enim imperdiet dolor, sodales maximus
  purus quam in ligula.Nulla hendrerit eu ex quis malesuada.Nulla
  imperdiet efficitur ipsum.Sed rutrum elementum vehicula.Praesent odio
  nisl, elementum lacinia aliquet vel, hendrerit eu arcu.Aliquam at
  pharetra est.Nunc sem neque, blandit ut mauris eu, lobortis malesuada
  eros.Nulla sit amet felis sed erat sagittis elementum.Nam mattis
  congue porta.Donec ac tellus commodo, rhoncus sem sit amet, faucibus
  neque.Interdum et malesuada fames ac ante ipsum primis in faucibus.
  Etiam sed est ac eros luctus vestibulum.In non lacinia urna.Aenean
  scelerisque rhoncus massa, vitae interdum turpis volutpat egestas.
  Suspendisse elementum ipsum nibh, sit amet convallis neque euismod
  pharetra.Sed luctus sem a nunc scelerisque congue.Nam at urna cursus,
    ullamcorper felis commodo, malesuada orci.Vestibulum tempus quam vitae
  velit maximus, ac eleifend orci iaculis.Duis ornare pretium eros id
  interdum.Nullam feugiat orci non dolor tristique, eget mollis enim
  posuere.Praesent et dolor finibus, egestas felis eu, efficitur sapien.
  Vivamus eget lectus mollis, luctus urna quis, tempor ligula.Aenean quis
  ullamcorper massa.Curabitur vel ex lectus.Quisque varius pulvinar
  imperdiet.Proin id augue ac libero lobortis consectetur.Proin volutpat
  nunc vitae eros varius, nec mattis elit mollis.Mauris convallis diam eu
  ex tincidunt, quis malesuada odio porttitor.Pellentesque porttitor
  lacinia magna sit amet pulvinar.Nullam eu consectetur felis, eget
  lacinia dui.Donec rhoncus nulla et urna fermentum, eget sagittis nisi
  consectetur.Phasellus cursus eu eros at blandit.Ut at lobortis neque.
  Duis sollicitudin erat sem, ac lobortis quam porttitor sed.Suspendisse
  lacinia sapien vitae elit bibendum, eu accumsan eros pretium.Maecenas
  et metus at eros facilisis sodales sed quis lectus.In ex nisl,
    porttitor eu erat sit amet, porttitor eleifend quam.Nam tristique
  finibus nisi rhoncus dictum.Nam elementum hendrerit justo nec
  fringilla.Ut quis dolor justo.Curabitur commodo placerat augue, eu
  bibendum erat dapibus quis.Aliquam imperdiet sit amet massa id gravida.
  Morbi consequat risus eget finibus aliquet.Aliquam purus urna, congue
  non volutpat quis, placerat ultricies risus.Vestibulum ante ipsum
  primis in faucibus orci luctus et ultrices posuere cubilia curae; Nunc
  viverra finibus massa, id auctor massa volutpat a.Sed quis egestas
  lacus.Pellentesque habitant morbi tristique senectus et netus et
  malesuada fames ac turpis egestas.Praesent tincidunt tortor augue,
    fermentum egestas massa porta interdum.`,
    textRules: 'Regras do condomínio',
};
exports.default = DescriptionModal;
